export const isTargetSelfDomain: (url: string) => boolean = (url: string) => {
  try {
    const domain = new URL(url).hostname;
    return DOMAINS.includes(domain);
  } catch {
    return false;
  }
};

const DOMAINS = ['accounts.sparkasse.de', 'stage-accounts.sparkasse.de', 'immobilien.sparkasse.de'];
